// =============================================================================
// CẤU HÌNH ĐỘNG NSKH 2026 — Giải thưởng Nữ sinh KHCN (scene GTNS)
// Gom các link tài liệu có thể thay đổi vào một chỗ để dễ chỉnh sửa.
// Dán URL thật vào các trường bên dưới (để rỗng "" thì UI tự ẩn link/nút).
// =============================================================================

export const GTNS2026_LINKS = {
  // Toàn bộ Quyết định kèm Quy chế Giải thưởng (PDF / Google Drive...)
  quyetDinhQuyChe:
    "https://drive.google.com/file/d/1KJx-08R8ci_SZgAFIJlYkckNA4b7vYn1/view?usp=drive_link",
  // Link nhúng (preview) bản PDF quy chế để hiển thị ngay trong trang
  quyChePdfEmbed:
    "https://drive.google.com/file/d/1KJx-08R8ci_SZgAFIJlYkckNA4b7vYn1/preview",
  // Mẫu file CV đề cử năm 2026 (Công văn giới thiệu của đơn vị đề cử)
  mauCvDeCu:
    "https://docs.google.com/document/d/10v9NK9bpdC9M4r53c03tEvf8p2CJOeMU/edit",
  // Phụ lục các ngành thuộc các nhóm ngành
  phuLucNganh:
    "https://docs.google.com/document/d/1M50Xyp-FcaeOxego8mFIAz6ChzUl-vr3/edit?usp=drive_link&ouid=104949695731583057949&rtpof=true&sd=true",
  // Mẫu Bản cam kết của ứng viên (mục F)
  mauCamKet:
    "https://docs.google.com/document/d/1H93muzo3ebexcNzY-g8tTQAMoRwKz_2kvY5pnATH4Fk/edit?usp=sharing",
};

// E. ƯU TIÊN — các mục ưu tiên (lưu vào field `priority` JSON ở backend)
export const GTNS2026_PRIORITY_FIELDS = [
  { key: "isEthnicMinority", label: "Là nữ sinh người dân tộc thiểu số" },
  { key: "isDisabled", label: "Là sinh viên khuyết tật" },
];
